export default import.meta.ROLLDOWN_FILE_URL_A6qqyAQW0zWGfSOXFG877Q